import type { FaireProductEntity } from "../../entity_types/product";

export const p_9bf575ybj8: FaireProductEntity = {
  token: "p_9bf575ybj8",
  type: "product",
  name: "Chile Sauce Variety Case",
  brandToken: "b_nn2hu33twq",
  brandName: "Sauce Everywhere",
  imageUrl:
    "https://cdn.faire.com/fastly/ea924275bacf861984b994ea9cc292718f34bee412210b3bc2bd861b0ba0fffd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/174c529dc865c83143e2456c112b96ddf2ffbb5a6049d3b9ca94e814e927c2e4.jpeg",
    "https://cdn.faire.com/fastly/2038ec5c56711f99ae34e509ef5bd1844c432d7a1d61a06e1e23336bf84318e0.jpeg",
    "https://cdn.faire.com/fastly/8268f0b9ddda999f2ece6be70d5c65c6454409d3955a13ff1b057d024a2357c1.jpeg",
    "https://cdn.faire.com/fastly/13f04b82cee339ffc13df3baac086a7a7665535ba420e9132dac6e6eb0d49484.jpeg",
    "https://cdn.faire.com/fastly/66746adf4b770793a9943f858a4736caec57965b8f7e8bbc9791a1299a964392.jpeg",
  ],
  priceDollars: 11,
  description:
    "Four of each of our best sellers. Ají Crisp, Casera, and Negra are a power trio of everyday sauces that elevate the flavor of any meal. \n\nAjí Crisp is a salsa macha / chili crisp hybrid that brings a crunchy bite of fruity oil. Casera is similar to a red enchilada sauce (with tomatoes) that has a jammy, earthy complexity. And Negra is a mole with a barbecue sauce taste that's smoky and sweet. \n\nAll three are medium spicy, and great as ingredients or toppings. \n\nThey're most popular on rice dishes, eggs, and cheese dishes respectively. But we made each of these chile sauces to give any meal a savory boost. \n\n🫙 Sold in an 8 oz. reusable glass jar \n📦 $132 per case (12 jars) \n🌶️ Made in Pueblo, CO",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:12.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
